import { render, staticRenderFns } from "./Bnu.vue?vue&type=template&id=f2c960b8"
import script from "./Bnu.vue?vue&type=script&lang=js"
export * from "./Bnu.vue?vue&type=script&lang=js"
import style0 from "./Bnu.vue?vue&type=style&index=0&id=f2c960b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports